import React from "react";
import ZestVideoPlayer from "~/common/videoPlayer/ZestVideoPlayer";
import { BuyingGuideSection } from "../Types/BuyingGuideSection";
import sendVideoPlayEvent from "~/common/MediaViewerV2/sendVideoPlayEvent";

export default function BuyingGuideVideo({
  section,
}: {
  section: BuyingGuideSection;
}) {
  const video = section?.contents[0]?.video ?? undefined;

  return (
    <div className="guide-section video-template">
      {section.heading?.length > 0 && <h2>{section.heading}</h2>}
      {video && (
        <div className="aspect-video">
          <ZestVideoPlayer
            onPlay={() => sendVideoPlayEvent(video.sources)}
            posterImage={video.poster}
            sources={video.sources}
            currentIndex={0}
            selected={0}
            activePlayer={false}
            youtubeId={video.youtubeId}
            useCdn
            playsInline
            closedCaptionsrc={video.closedCaptionFile}
          />
        </div>
      )}
    </div>
  );
}
